import * as React from "react";
import { Upload } from "../models/upload";

export const UploadItem = (props: { upload: Upload; delete?: () => void }) => {
  let { upload } = props;
  let background = upload.uploadComplete
    ? "inherit"
    : `linear-gradient(to right, lightblue, lightblue ${
        upload.uploadProgress
      }%, transparent  ${upload.uploadProgress + 5}%, transparent 100% )`;
  return (
    <tr key={upload.id} style={{ background }}>
      <td>
        {upload.href && upload.uploadComplete ? (
          <a href={upload.href}>{upload.filename}</a>
        ) : (
          upload.filename
        )}
      </td>
      <td>{(upload.size / (1024 * 1024)).toFixed(2)}mb</td>
      <td>{props.delete ? <a onClick={props.delete}>Delete</a> : undefined}</td>
    </tr>
  );
};
